export default __webpack_public_path__ + "static/media/ferramenta-reels-img10.ae2774d9.jpeg";